import React from 'react';
import { isQuillEmpty } from '../../../utils/quill';
import { Button, Stack, TextField, CircularProgress, Typography, Divider, Box, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import DialogDocumentDetails from '../Vehicle_Components/DialogDocumentDetails';
import DialogCalibrationDetails from '../Vehicle_Components/DialogCalibrationDetails';
import DialogPacketDetails from '../Vehicle_Components/DialogPacketDetails';
// ReactMarkdown usage centralized in MarkdownRenderer (helpers.js)
import { Chip } from '@mui/material';
import ChatComponent from './ChatComponent';

import SearchControls from './SearchControls';
import ResultsTable from './ResultsTable';
import getTexts from './i18n';
import { formatAiResponse, MarkdownRenderer } from './helpers';

export default class FeasibilityPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      brand: '',
      model: '',
      engineCode: '',
      carModelOptions: [],
      engineCodeOptions: [],
      brandMachines: [],
      carBrands: [],
      loadingModels: false,
      loadingEngineCodes: false,
      results: [],
      brandInput: '',
      openRows: {},      
      detailsPackageId: null,
      detailsCalibrationId: null,
      detailsDocumentId: null,
      comBrand: this.props.comBrand || '',

      // New state for AI search
      searchMode: this.props.searchAi ? 'chat' : 'classic', // 'classic', 'ai', 'chat'
      aiQuery: 'ho una alfa tonale, mostra collegamenti elettrici', //// Default query for testing
      aiLoading: false,
      aiQueryQuestion: '',
      aiQueryResult: '',
      showAiResultDialog: false,
      selectedDocumentForAi: null,
      
      // For classic search AI query
      showClassicAiQuestionDialog: false,
      classicAiQuestion: '',
      
      // For AI result dialog
      questionForDialog: '',

      // Chat state moved to ChatComponent
    };
    this.brandTimeout = null;
    // Chat refs moved inside ChatComponent
  }

  handleModeChange = (event, newValue) => {
    this.setState({ searchMode: newValue, results: [] });
  };

  handleAiDocQuery = async (doc, question) => {
    //alert(JSON.stringify(doc));      
    const questionToAsk = question || this.state.aiQueryQuestion;
    if (!questionToAsk) {
      alert("Nessuna domanda da porre.");
      return;
    }
    this.setState({ aiLoading: true, selectedDocumentForAi: doc, questionForDialog: questionToAsk });
    try {
      const res = await AppDocuServiceCall.feasibilityAskAi(questionToAsk, doc.file_hash);
      if (res.data && res.data.result) {
        this.setState({
          aiQueryResult: res.data.result,
          showAiResultDialog: true,
        });
      } else {
        alert('La query AI non ha prodotto risultati.');
      }
    } catch (error) {
      console.error("AI Query Error:", error);
      alert('Errore durante l\'interrogazione del documento.');
    } finally {
      this.setState({ aiLoading: false });
    }
  };

  handleOpenClassicAiQuestionDialog = (doc) => {
    //alert(JSON.stringify(doc));
    this.setState({ selectedDocumentForAi: doc, showClassicAiQuestionDialog: true });
  };

  handleCloseClassicAiQuestionDialog = () => {
    this.setState({ 
      showClassicAiQuestionDialog: false, 
      classicAiQuestion: '', 
      ///selectedDocumentForAi: null 
    });
  };

  handleClassicAiQuestionChange = (event) => {
    this.setState({ classicAiQuestion: event.target.value });
  };

  handleClassicAiQuery = () => {
    const { selectedDocumentForAi, classicAiQuestion } = this.state;
    if (selectedDocumentForAi && classicAiQuestion) {
      this.handleAiDocQuery(selectedDocumentForAi, classicAiQuestion);
      this.handleCloseClassicAiQuestionDialog();
    }
  };

  formatAiResponse = (text, file_hash) => {
    return formatAiResponse(text, file_hash);
  };

  handleCloseAiResultDialog = () => {
    this.setState({ showAiResultDialog: false, aiQueryResult: '', selectedDocumentForAi: null, questionForDialog: '' });
  };

  handleBrandInputChange = (event, newInputValue) => {
    if (newInputValue !== this.state.brandInput) {
      this.setState({
        brandInput: newInputValue,
        brand: newInputValue,
        model: '',
        engineCode: '',
        carModelOptions: [],
        engineCodeOptions: [],
        loadingModels: true,
      });
      if (this.brandTimeout) clearTimeout(this.brandTimeout);
      this.brandTimeout = setTimeout(() => {
        AppDocuServiceCall.feasibilityList({ brand: newInputValue })
          .then(res => {
            const data = Array.isArray(res.data) ? res.data : (res.data.result || []);
            const seen = new Set();
            const models = Array.isArray(data)
              ? data.map(m => m.model).filter(model => {
                  if (!model || seen.has(model)) return false;
                  seen.add(model);
                  return true;
                })
              : [];
            this.setState({
              brandMachines: data,
              carModelOptions: models,
              loadingModels: false
            });
          })
          .catch(() => {
            this.setState({ carModelOptions: [], brandMachines: [], loadingModels: false });
          });
      }, 500);
    }
  };

  handleModelInputChange = (event, newInputValue) => {
    const { brandMachines } = this.state;
    this.setState({
      model: newInputValue,
      engineCode: '',
      loadingEngineCodes: true
    });
    if (!newInputValue) {
      this.setState({ engineCodeOptions: [], loadingEngineCodes: false });
      return;
    }
    const engineCodes = brandMachines
      .filter(m => m.model === newInputValue && m.engine_code)
      .map(m => m.engine_code)
      .filter((code, idx, arr) => code && arr.indexOf(code) === idx);
    this.setState({
      engineCodeOptions: engineCodes,
      loadingEngineCodes: false
    });
  };

  handleEngineCodeInputChange = (event, newInputValue) => {
    this.setState({ engineCode: newInputValue });
  };

  handleSearch = async () => {
    const { brand, model, engineCode, comBrand } = this.state;
    if (!comBrand) {
      alert('Com Brand mancante');
      return;
    }
    // if (!brand || !model) {
    //   alert('Inserire almeno Marca e Modello');
    //   return;
    // }
    this.setState({ loading: true, results: [] });
    try {
      var res = await AppDocuServiceCall.feasibilitySearch(brand, model, engineCode, comBrand)
      if (!res) {
        alert('Error fetching data');
        this.setState({ loading: false });
      } else if (res.data.is_valid === false) {
        alert(res.data.message);
        this.setState({ loading: false });
      } else {
        const results = res.data.result || [];
        if (Array.isArray(results) && results.length === 0) {
          alert('Nessun risultato trovato');
        }
        this.setState({ results, loading: false, openRows: {} });
      }
    } catch (error) {
      alert('Error fetching data');
      this.setState({ loading: false });
    }
  };

  handleToggleRow = (idx) => {
    this.setState((prev) => ({
      openRows: { ...prev.openRows, [idx]: !prev.openRows[idx] }
    }));
  };

  handleOpenDownloadDialog = (type, id) => {
    if (type === 'package') {
      this.setState({ detailsPackageId: id });
    } else if (type === 'calibration') {
      this.setState({ detailsCalibrationId: id });
    } else if (type === 'document') {
      this.setState({ detailsDocumentId: id });
    } 
  };

  handleCloseDialog = () => {
    this.setState({ detailsPackageId: null, detailsCalibrationId: null, detailsDocumentId: null });
  };

  async componentDidMount() {
    // Load carBrands dynamically
    try {
      const res = await AppDocuServiceCall.feasibilityList();
      const data = Array.isArray(res.data) ? res.data : (res.data.result || []);
      const seen = new Set();
      const brands = Array.isArray(data)
        ? data.map(m => m.brand).filter(brand => {
            if (!brand || seen.has(brand)) return false;
            seen.add(brand);
            return true;
          })
        : [];
      this.setState({ carBrands: brands });
    } catch (e) {
      this.setState({ carBrands: [] });
    }
    if (this.state.comBrand) {
      // ...existing code...
    }

  }

  render() {
  const { loading, brand, model, engineCode, carModelOptions, engineCodeOptions, carBrands, loadingModels, loadingEngineCodes, results, brandInput, openRows, searchMode, aiQuery, aiLoading, aiQueryResult, showAiResultDialog, selectedDocumentForAi, showClassicAiQuestionDialog, classicAiQuestion, questionForDialog } = this.state;
    const lang = this.props.lang || 'it';
    const t = getTexts(lang, this.state.comBrand);

    // Calculate height using navbarHeight prop
    const navbarHeightPx = parseInt(this.props.navbarHeight, 10) || 84;
    const containerHeight = `calc(100vh - ${navbarHeightPx}px)`;

    return (
      <Box sx={{ 
        p: 3, 
        overflowX: 'hidden', 
        width: '100%', 
        minHeight: containerHeight,
        boxSizing: 'border-box'
      }}>
        <Typography variant="h4" gutterBottom>{t.title}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ textTransform: 'uppercase', mb: 2 }}>
          {/* SE NON HAI TROVATO QUELLO CHE CERCHI, CLICCA QUI PER APRIRE UNA SEGNALAZIONE */}
        </Typography>

        <SearchControls
          searchMode={searchMode}
          onModeChange={this.handleModeChange}
          t={t}
          carBrands={carBrands}
          brand={brand}
          brandInput={brandInput}
          onBrandInputChange={this.handleBrandInputChange}
          carModelOptions={carModelOptions}
          model={model}
          onModelInputChange={this.handleModelInputChange}
          engineCodeOptions={engineCodeOptions}
          engineCode={engineCode}
          onEngineCodeInputChange={this.handleEngineCodeInputChange}
          loadingModels={loadingModels}
          loadingEngineCodes={loadingEngineCodes}
          onSearch={this.handleSearch}
          searchAi={this.props.searchAi}
          aiQuery={aiQuery}
          aiLoading={aiLoading}
          renderClassicInputs={() => (
            <>
              <Autocomplete sx={{ width: '100%' }} options={carBrands} value={brand} inputValue={brandInput} onInputChange={this.handleBrandInputChange} renderInput={(params) => <TextField {...params} label={t.marca} />} loading={loadingModels} />
              <Autocomplete sx={{ width: '100%' }} options={carModelOptions} value={model} inputValue={model} onInputChange={this.handleModelInputChange} renderInput={(params) => <TextField {...params} label={t.modello} />} noOptionsText={t.selectBrandFirst} loading={loadingModels} />
              <Autocomplete sx={{ width: '100%' }} options={engineCodeOptions} value={engineCode} inputValue={engineCode} onInputChange={this.handleEngineCodeInputChange} renderInput={(params) => <TextField {...params} label={t.codiceMotore} />} noOptionsText={t.selectBrandAndModelFirst} loading={loadingEngineCodes} />
            </>
          )}
        />

        {searchMode !== 'chat' && (
        <><Divider sx={{ mb: 2 }} />
          <ResultsTable
            results={results}
            openRows={openRows}
            onToggleRow={this.handleToggleRow}
            onOpenDownloadDialog={this.handleOpenDownloadDialog}
            t={t}
            searchAi={this.props.searchAi}
            aiLoading={aiLoading}
            selectedDocumentForAi={selectedDocumentForAi}
            onAiDocQuery={this.handleAiDocQuery}
            onOpenClassicAiQuestionDialog={this.handleOpenClassicAiQuestionDialog}
            searchMode={searchMode}
          />
          </>
        )}

        {searchMode === 'chat' && (
          <ChatComponent
            t={t}
            lang={lang}
            comBrand={this.state.comBrand}
            navbarHeight={this.props.navbarHeight}
            onOpenDownloadDialog={this.handleOpenDownloadDialog}
            onOpenClassicAiQuestionDialog={this.handleOpenClassicAiQuestionDialog}
          />
        )}

        {/* Dialogs */}
        
        <DialogDocumentDetails
          open={!!this.state.detailsDocumentId}
          documentId={this.state.detailsDocumentId}
          onClose={() => this.setState({ detailsDocumentId: null })}
        />
        <DialogPacketDetails
          showEdit={false}
          open={!!this.state.detailsPackageId}
          packageId={this.state.detailsPackageId}
          onClose={() => this.setState({ detailsPackageId: null })}
        />
        <DialogCalibrationDetails
          showEdit={false}
          open={!!this.state.detailsCalibrationId}
          calibrationId={this.state.detailsCalibrationId}
          onClose={() => this.setState({ detailsCalibrationId: null })}
        />

        <Dialog open={showAiResultDialog} onClose={this.handleCloseAiResultDialog} maxWidth="md" fullWidth>
          <DialogTitle>{questionForDialog}</DialogTitle>
          <DialogContent>
            <Box sx={{ '& a': { color: 'primary.main' }, '& a:visited': { color: 'primary.dark' } }}>
              <MarkdownRenderer onDocClick={(hash)=>{ /* no-op for dialog view */ }} userRole={'assistant'}>{this.formatAiResponse(aiQueryResult, selectedDocumentForAi?.file_hash)}</MarkdownRenderer>
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
              {t.aiDisclaimer}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseAiResultDialog}>Chiudi</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={showClassicAiQuestionDialog} onClose={this.handleCloseClassicAiQuestionDialog} maxWidth="sm" fullWidth>
          <DialogTitle>{t.classicAiQuestionTitle}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="classic-ai-question"
              label={t.classicAiQuestionLabel}
              type="text"
              fullWidth
              variant="standard"
              value={classicAiQuestion}
              onChange={this.handleClassicAiQuestionChange}
              onKeyPress={(ev) => {
                if (ev.key === 'Enter') {
                  this.handleClassicAiQuery();
                  ev.preventDefault();
                }
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseClassicAiQuestionDialog}>Annulla</Button>
            <Button onClick={this.handleClassicAiQuery} disabled={!classicAiQuestion.trim()}>{t.ask}</Button>
          </DialogActions>
        </Dialog>

      </Box>
    );
  }
}
